import { Modal } from 'antd';
import TcDevider from 'components/UI/Devider/TcDevider';
import TcInput from 'components/UI/form/input/TcInput';
import TcRadioReduxSearch from 'components/UI/form/input/TcRadioReduxSearch';
import TcSelect from 'components/UI/form/input/TcSelect';
import TcFormItem from 'components/UI/form/TcFormItem';
import TcModal from 'components/UI/Modal/TcModal';
import { englishNumberOnly, separator } from 'global/default';
import { ISelectOptions } from 'global/Models/globalModels';
import { packagingContent, packagingGroup, packagingType } from 'global/Models/packaging';
import { FC, FocusEvent, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getPackagingGroup } from 'redux/reducer/packaging/getPackagingGroup';
import { getCustomerFinancialInfo } from 'redux/reducer/user/getCustomerFinancialInfo';
import { RootState, store } from 'redux/store';

interface IPackagingFormItems {
  selectedPackagingType?: packagingType;
  packagingTypeList?: packagingType[];
  packagingContent?: packagingContent[];
  noTitle?: boolean;
  inputPriceValue?: string;
  selectingPackagingGroup: packagingGroup;
  setSelectingPackagingGroupId: React.Dispatch<React.SetStateAction<packagingGroup>>;
  showFloorNotification?: boolean;
}
const PackagingFormItems: FC<IPackagingFormItems> = ({
  selectedPackagingType,
  packagingTypeList,
  packagingContent,
  inputPriceValue,
  selectingPackagingGroup,
  setSelectingPackagingGroupId,
  noTitle,
  showFloorNotification,
}) => {
  //state
  const { customerFinancialInfo, userProfile } = useSelector((state: RootState) => state.user);
  const [modalOpen, setModalOpen] = useState(false);
  const { branches } = useSelector((state: any) => state.userBranches.value);
  //effect
  useEffect(() => {
    if (userProfile && userProfile.personId) {
      !customerFinancialInfo && store.dispatch(getCustomerFinancialInfo());
    }
  }, [userProfile]);

  //constant
  const modifiedPackagingContent = packagingContent?.map((packaging) => {
    if (packaging.latinTitle === 'LiquidOrBreakable') {
      return { ...packaging, title: 'شکستنی' };
    } else {
      return packaging;
    }
  });

  const maxPriceValue =
    customerFinancialInfo &&
    customerFinancialInfo?.creditAmount > 0 &&
    selectingPackagingGroup?.id !== 10 &&
    selectingPackagingGroup?.id !== 50 &&
    selectingPackagingGroup?.id !== 70
      ? 3000000000
      : customerFinancialInfo && customerFinancialInfo?.creditAmount > 0 && selectingPackagingGroup?.id === 70
      ? selectedPackagingType?.contractCustomerMaxPrice
      : selectingPackagingGroup?.ceilingCompensationPrice;

  const handleClick = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  const [modal, contextHolder] = Modal.useModal();
  const floorPopupShown = useRef(false);

  const handlePriceBlur = (e: FocusEvent<HTMLInputElement>) => {
    if (!showFloorNotification) return;
    const entered = Number(englishNumberOnly(e.target.value));
    const minPrice = selectedPackagingType?.minPrice;
    if (!minPrice) return;
    if (entered > 0 && entered < minPrice) {
      if (floorPopupShown.current) return;
      floorPopupShown.current = true;
      modal.info({
        title: 'اطلاع رسانی حداقل ارزش مرسوله',
        content: (
          <div>
            <p>
              کاربر گرامی، حداقل ارزش مرسوله برای بسته بندی «{selectedPackagingType?.title}» معادل {separator(minPrice)} ریال تعیین شده است.
            </p>
            <p>
              مبلغ وارد شده ({separator(entered)} ریال) کمتر از حداقل تعیین شده بوده و مبلغ مبنای محاسبه جبران خسارت و اعمال در قیمت، مطابق حداقل تعیین شده یعنی{' '}
              {separator(minPrice)} ریال اعمال خواهد شد.
            </p>
          </div>
        ),
        okText: 'متوجه شدم',
      });
    } else if (entered >= minPrice) {
      floorPopupShown.current = false;
    }
  };
  return (
    <>
      <div className='flex items-center justify-between w-full px-3 py-2 rounded-lg shadow-md col-span-full bg-blue-200/30 backdrop-blur-sm'>
        <span className='text-xs text-t-first-text-color'>کاربر گرامی جهت اطلاع از بسته مناسب برای بسته‌بندی، مشاهده کنید.</span>
        <span onClick={handleClick} className='text-blue-600 cursor-pointer hover'>
          مشاهده
        </span>
        <TcModal title='بسته مناسب' visible={modalOpen} onCancel={handleClose} width={600} footer={false}>
          <div>
            <p>ابعاد بسته استاندارد به شکل زیر تعریف شده است:</p>
            <p>طول: بین 10 تا 90 سانتیمتر</p>
            <p>عرض: بین 10 تا 80 سانتیمتر</p>
            <p>ارتفاع: بین 10 تا 70 سانتیمتر</p>
            <br></br>
            <p>
              کاربر گرامی، اگر حداقل یکی از ابعاد بسته شما کمتر از ۱۰ سانتی‌متر باشد، پیشنهاد می‌کنیم برای جلوگیری از احتمال مفقودی آن، از بخش بسته‌بندی، کارتن سایز 1، پاکت و یا
              مینی‌پک را انتخاب کنید.
            </p>
            <br></br>
            <p>
              اگر طول، عرض و ارتفاع بسته شما بیشتر از 90، 80 و 70 سانتی‌متر باشد نیز، پیشنهاد می‌کنیم برای جلوگیری از احتمال مفقودی آن، از بخش بسته‌بندی، کارتن سایز بزرگ و حجیم را
              انتخاب کنید.
            </p>
          </div>
        </TcModal>
      </div>
      <TcFormItem name='packagingGroupId' label='نوع مرسوله' rules={[{ required: true, message: 'نوع تعیین نشده' }]} full>
        <TcRadioReduxSearch
          reducerName='packaging'
          reducerListProperty='packagingGroup'
          getlist={getPackagingGroup}
          onChangeFullInfo={(value: packagingGroup) => {
            setSelectingPackagingGroupId(value);
          }}
        />
      </TcFormItem>

      <div className='col-span-full '>
        <TcDevider>آیا مرسوله نیاز به بسته بندی دارد؟</TcDevider>
        <TcFormItem name='packagingTypeId' label='بسته بندی' rules={[{ required: true, message: ' بسته بندی تعیین نشده' }]} validateTrigger='onSubmit'>
          <TcSelect
            options={packagingTypeList?.map((item) => ({
              value: item.id,
              label: item.order === 0 ? item.title : `${item.title} - طول ${item.length} / عرض ${item.width} / ارتفاع ${item.height}`,
              item: item,
            }))}
          />
        </TcFormItem>
        {!selectedPackagingType?.editable && selectedPackagingType?.minLength && selectedPackagingType.minWidth && selectedPackagingType.minHeight ? (
          <div className='mt-2 text-xs text-t-secondary-text-color'>
            بسته بندی {selectedPackagingType?.title} با طول {selectedPackagingType.minLength} ، عرض {selectedPackagingType.minWidth} و ارتفاع {selectedPackagingType.minHeight} سانت
          </div>
        ) : (
          <></>
        )}
      </div>

      <div className='col-span-full'>
        <TcDevider>مشخصات مرسوله</TcDevider>
      </div>
      {!noTitle && (
        <TcFormItem name='title' label='عنوان' rules={[{ required: true, message: ' عنوان تعیین نشده' }]}>
          <TcInput placeholder='عنوان' />
        </TcFormItem>
      )}
      <TcFormItem name='packagingContentId' label='محتویات' rules={[{ required: true, message: ' محتویات تعیین نشده' }]}>
        <TcSelect options={modifiedPackagingContent?.map((item: ISelectOptions) => ({ value: item.id, label: item.title }))} />
      </TcFormItem>
      <div className=''>
        <TcFormItem
          name='price'
          label='ارزش'
          rules={[
            {
              required: true,
              message: 'ارزش مرسوله را وارد کنید',
            },
            {
              validator: (_rule, value) => {
                // if (!selectedPackagingType) return Promise.reject(new Error('لطفا بسته بندی را انتخاب کنید.'));
                if (
                  maxPriceValue &&
                  // value >= selectedPackagingType.minPrice
                  value > 0 &&
                  value <= maxPriceValue
                ) {
                  return Promise.resolve();
                }
                // if (value < selectedPackagingType.minPrice)
                if (value == 0) return Promise.reject(new Error(`ارزش مرسوله حداقل باید ${separator(selectingPackagingGroup.floorCompensationPrice)} ریال باشد`));
                return Promise.reject(new Error(`ارزش وارد شده بیشتر از ${separator(maxPriceValue)}ریال است.`));
              },
            },
          ]}>
          <TcInput onBlur={handlePriceBlur} suffix='ریال' min={selectingPackagingGroup.floorCompensationPrice} max={maxPriceValue} placeholder='ارزش مرسوله' />
        </TcFormItem>
        {selectedPackagingType && (
          <span className='block mt-1 text-xs text-t-secondary-text-color'>
            ارزش تا
            {/* از {separator(selectedPackagingType?.minPrice)} */}
            <span className='px-1 text-xs text-t-secondary-text-color'> {separator(maxPriceValue)} ریال</span>
          </span>
        )}
        {inputPriceValue && <span className='block text-xs text-t-secondary-text-color'>{inputPriceValue}</span>}
      </div>
      <div>
        <TcFormItem
          name='weight'
          label='وزن (کیلوگرم)'
          rules={[
            {
              required: true,
              message: 'وزن مرسوله را وارد کنید',
            },
            {
              validator: (_rule, value) => {
                // If packaging group is 60 enforce 30-100 kg
                if (selectingPackagingGroup?.id === 60) {
                  if (value > 0 && value >= 30 && value <= 100) return Promise.resolve();
                  if (value == 0) return Promise.reject(new Error('وزن مرسوله نباید صفر باشد!'));
                  if (value < 30) return Promise.reject(new Error(`وزن مرسوله حداقل باید ${separator(30)} کیلوگرم باشد`));
                  return Promise.reject(new Error(`وزن وارد شده بیشتر از ${separator(100)} کیلوگرم است.`));
                }

                if (!selectedPackagingType) return Promise.reject(new Error('لطفا بسته بندی را انتخاب کنید.'));
                if (
                  // value >= selectedPackagingType.minWeight
                  value > 0 &&
                  value <= selectedPackagingType.maxWeight
                ) {
                  return Promise.resolve();
                }
                if (
                  value == 0
                  // selectedPackagingType.minWeight
                )
                  return Promise.reject(new Error('وزن مرسوله نباید صفر باشد!'));
                return Promise.reject(new Error(`وزن وارد شده بیشتر از ${separator(selectedPackagingType.maxWeight)}کیلوگرم است.`));
              },
            },
          ]}>
          <TcInput placeholder='وزن مرسوله' suffix='kg' />
        </TcFormItem>
        {selectedPackagingType && selectingPackagingGroup?.id !== 60 && (
          <span className='text-xs text-t-secondary-text-color'>
            وزن تا
            {/* از {separator(selectedPackagingType?.minWeight)} */}
            <span className='px-1 text-xs text-t-secondary-text-color'> {separator(selectedPackagingType?.maxWeight)} کیلوگرم</span>
          </span>
        )}
        {selectedPackagingType && selectingPackagingGroup?.id === 60 && <span className='text-xs text-t-secondary-text-color'>وزن از 30 تا 100 کیلوگرم</span>}
      </div>
      {selectedPackagingType?.maxGlueAmount !== 0 && branches.length > 0 && (
        <div>
          <TcFormItem
            name='glueAmount'
            label='هزینه چسب'
            rules={[
              {
                required: true,
                message: 'هزینه چسب را وارد کنید',
              },
              {
                validator: (_rule, value) => {
                  if (!selectedPackagingType) return Promise.reject(new Error('لطفا بسته بندی را انتخاب کنید.'));
                  if (value > 0 && value <= selectedPackagingType.maxGlueAmount) {
                    return Promise.resolve();
                  }
                  if (value == 0) return Promise.reject(new Error('هزینه چسب مرسوله نباید صفر باشد'));
                  return Promise.reject(new Error(`هزینه چسب وارد شده بیشتر از ${separator(selectedPackagingType.maxGlueAmount)} است.`));
                },
              },
            ]}>
            <TcInput placeholder='هزینه چسب' suffix='ریال' />
          </TcFormItem>
          {selectedPackagingType && (
            <span className='text-xs text-t-secondary-text-color'>
              هزینه چسب تا
              <span className='px-1 text-xs text-t-secondary-text-color'> {separator(selectedPackagingType?.maxGlueAmount)}ریال</span>
            </span>
          )}
        </div>
      )}
      {selectedPackagingType?.maxBubbleWrapAmount !== 0 && branches.length > 0 && (
        <div>
          <TcFormItem
            name='bubbleWrapAmount'
            label='هزینه نایلون حباب‌دار'
            rules={[
              {
                required: true,
                message: 'هزینه نایلون حباب‌دار را وارد کنید',
              },
              {
                validator: (_rule, value) => {
                  if (!selectedPackagingType) return Promise.reject(new Error('لطفا بسته بندی را انتخاب کنید.'));
                  if (value > 0 && value <= selectedPackagingType.maxBubbleWrapAmount) {
                    return Promise.resolve();
                  }
                  if (value == 0) return Promise.reject(new Error('هزینه نایلون حباب‌دار نباید صفر باشد!'));
                  return Promise.reject(new Error(`هزینه نایلون حباب‌دار وارد شده بیشتر از ${separator(selectedPackagingType.maxBubbleWrapAmount)} است.`));
                },
              },
            ]}>
            <TcInput placeholder='هزینه نایلون حباب‌دار' suffix='ریال' />
          </TcFormItem>
          {selectedPackagingType && (
            <span className='text-xs text-t-secondary-text-color'>
              هزینه نایلون حباب‌دار تا
              <span className='px-1 text-xs text-t-secondary-text-color'> {separator(selectedPackagingType?.maxBubbleWrapAmount)}ریال</span>
            </span>
          )}
        </div>
      )}
      {selectedPackagingType?.maxSalary !== 0 && branches.length > 0 && (
        <div>
          <TcFormItem
            name='salary'
            label='هزینه بسته‌بندی'
            rules={[
              {
                required: true,
                message: 'هزینه بسته‌بندی را وارد کنید',
              },
              {
                validator: (_rule, value) => {
                  if (!selectedPackagingType) return Promise.reject(new Error('لطفا بسته‌بندی را انتخاب کنید.'));
                  if (value > 0 && value <= selectedPackagingType.maxSalary) {
                    return Promise.resolve();
                  }
                  if (value == 0) return Promise.reject(new Error('هزینه بسته‌بندی نباید صفر باشد!'));
                  return Promise.reject(new Error(`هزینه بسته‌بندی وارد شده بیشتر از ${separator(selectedPackagingType.maxSalary)} است.`));
                },
              },
            ]}>
            <TcInput placeholder='هزینه بسته‌بندی' suffix='ریال' />
          </TcFormItem>
          {selectedPackagingType && (
            <span className='text-xs text-t-secondary-text-color'>
              مقدار هزینه بسته‌بندی تا
              <span className='px-1 text-xs text-t-secondary-text-color'> {separator(selectedPackagingType?.maxSalary)} ریال</span>
            </span>
          )}
        </div>
      )}
      {selectedPackagingType?.editable && (
        <>
          <div className=''>
            <TcFormItem
              name='length'
              label='طول(سانتیمتر)'
              rules={[
                {
                  required: true,
                  message: 'طول مرسوله را وارد کنید',
                },
                {
                  validator: (_rule, value) => {
                    if (!selectedPackagingType) return Promise.reject(new Error('لطفا بسته بندی را انتخاب کنید.'));
                    if (value >= selectedPackagingType.minLength && value <= selectedPackagingType.maxLength) {
                      return Promise.resolve();
                    }
                    if (value < selectedPackagingType.minLength)
                      return Promise.reject(new Error(`طول مرسوله حداقل باید ${separator(selectedPackagingType.minLength)} سانتیمتر باشد`));
                    return Promise.reject(new Error(`طول وارد شده بیشتر از ${separator(selectedPackagingType.maxLength)}سانتیمتر است.`));
                  },
                },
              ]}>
              <TcInput placeholder='طول' suffix='cm' />
            </TcFormItem>
            <span className='text-xs text-t-secondary-text-color'>
              طول از {selectedPackagingType?.minLength} تا {selectedPackagingType?.maxLength} سانتیمتر
            </span>
          </div>
          <div>
            <TcFormItem
              name='width'
              label='عرض(سانتیمتر)'
              rules={[
                {
                  required: true,
                  message: 'عرض مرسوله را وارد کنید',
                },
                {
                  validator: (_rule, value) => {
                    if (!selectedPackagingType) return Promise.reject(new Error('لطفا بسته بندی را انتخاب کنید.'));
                    if (value >= selectedPackagingType.minWidth && value <= selectedPackagingType.maxWidth) {
                      return Promise.resolve();
                    }
                    if (value < selectedPackagingType.minWidth)
                      return Promise.reject(new Error(`عرض مرسوله حداقل باید ${separator(selectedPackagingType.minWidth)} سانتیمتر باشد`));
                    return Promise.reject(new Error(`عرض وارد شده بیشتر از ${separator(selectedPackagingType.maxWidth)}سانتیمتر است.`));
                  },
                },
              ]}>
              <TcInput placeholder='عرض' suffix='cm' />
            </TcFormItem>
            <span className='text-xs text-t-secondary-text-color'>
              عرض از {selectedPackagingType?.minWidth} تا {selectedPackagingType?.maxWidth} سانتیمتر
            </span>
          </div>
          <div className=''>
            <TcFormItem
              name='height'
              label='ارتفاع'
              rules={[
                {
                  required: true,
                  message: 'ارتفاع مرسوله را وارد کنید',
                },
                {
                  validator: (_rule, value) => {
                    if (!selectedPackagingType) return Promise.reject(new Error('لطفا بسته بندی را انتخاب کنید.'));
                    if (value >= selectedPackagingType.minHeight && value <= selectedPackagingType.maxHeight) {
                      return Promise.resolve();
                    }
                    if (value < selectedPackagingType.minLength)
                      return Promise.reject(new Error(`ارتفاع مرسوله حداقل باید ${separator(selectedPackagingType.minHeight)} سانتیمتر باشد`));
                    return Promise.reject(new Error(`ارتفاع وارد شده بیشتر از ${separator(selectedPackagingType.maxHeight)}سانتیمتر است.`));
                  },
                },
              ]}>
              <TcInput placeholder='ارتفاع' suffix='cm' />
            </TcFormItem>
            <span className='text-xs text-t-secondary-text-color'>
              ارتفاع از {selectedPackagingType?.minHeight} تا {selectedPackagingType?.maxHeight} سانتیمتر
            </span>
          </div>
        </>
      )}
      {/* {branches.length > 0 && (
        <>
          <div>
            <TcFormItem name='prefix' label='پیشوند بارکد' rules={[{ required: true, message: 'پیشوند بارکد را وارد کنید.' }]}>
              <TcInput placeholder='پیشوند بارکد' />
            </TcFormItem>
          </div>
          <div>
            <TcFormItem
              name='infix'
              label='بارکد عددی'
              rules={[
                {
                  required: true,
                  message: 'بارکد عددی مرسوله را وارد کنید',
                },
              ]}>
              <TcInput placeholder='بارکد عددی مرسوله' />
            </TcFormItem>
          </div>
        </>
      )} */}
      {contextHolder}
    </>
  );
};

export default PackagingFormItems;
